import { z } from 'zod';
import { defineEndpoint } from '../define';
import { DateFormatSchema, TimeFormatSchema } from './preferences';

const RoleSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  isSystem: z.boolean(),
});

const MeSchema = z.object({
  id: z.string().uuid(),
  firebaseUid: z.string(),
  email: z.string().email(),
  displayName: z.string(),
  // True until the user saves a display name; the web forces /profile while set.
  mustSetName: z.boolean(),
  // Null until the first-entry welcome celebration has played (marked via PATCH /me).
  welcomedAt: z.string().nullable(),
  githubUsername: z.string().nullable(),
  githubUsernameLocked: z.boolean(),
  githubName: z.string().nullable(),
  githubAvatarUrl: z.string().nullable(),
  dateFormat: DateFormatSchema.nullable(),
  timeFormat: TimeFormatSchema.nullable(),
  timezone: z.string().nullable(),
  /** Slack identity from Connect Slack (UCH-805); null until linked. */
  slackUserId: z.string().nullable(),
  slackLinkedAt: z.string().nullable(),
  /** Deep link to the bot's DM in Slack; null until linked or when SLACK_APP_ID is unset. */
  slackOpenUrl: z.string().nullable(),
  roles: z.array(RoleSchema).min(1),
  permissions: z.array(z.string()),
});

export const MeResponseSchema = z.object({
  data: MeSchema,
});

export type Me = z.infer<typeof MeSchema>;

export const getMe = defineEndpoint({
  method: 'GET',
  path: '/v1/auth/me',
  params: z.object({}),
  query: z.object({}),
  body: z.undefined(),
  response: MeResponseSchema,
});
